// @ts-nocheck


// This file was generated by [tauri-specta](https://github.com/oscartbeaumont/tauri-specta). Do not edit this file manually.

/** user-defined commands **/


export const commands = {
  async startOauthServer(): Promise<number> {
    return await TAURI_INVOKE("plugin:auth|start_oauth_server");
  },
  async stopOauthServer(port: number): Promise<null> {
    return await TAURI_INVOKE("plugin:auth|stop_oauth_server", { port });
  },
  async initVault(userId: string): Promise<null> {
    return await TAURI_INVOKE("plugin:auth|init_vault", { userId });
  },
  async resetVault(): Promise<null> {
    return await TAURI_INVOKE("plugin:auth|reset_vault");
  },
  async getFromVault(key: VaultKey): Promise<string | null> {
    return await TAURI_INVOKE("plugin:auth|get_from_vault", { key });
  },
  async getFromStore(key: StoreKey): Promise<string | null> {
    return await TAURI_INVOKE("plugin:auth|get_from_store", { key });
  },
  async setInVault(key: VaultKey, value: string): Promise<null> {
    return await TAURI_INVOKE("plugin:auth|set_in_vault", { key, value });
  },
  async setInStore(key: StoreKey, value: string): Promise<null> {
    return await TAURI_INVOKE("plugin:auth|set_in_store", { key, value });
  }
}

/** user-defined events **/


export const events = __makeEvents__<{
  authEvent: AuthEvent
}>({
  authEvent: "plugin:auth:auth-event"
})

/** user-defined constants **/



/** user-defined types **/

export type AuthEvent = "success" | { error: string }
export type RequestParams = { c: string; f: string; p: number }
export type ResponseParams = { ui: string; ai: string; st: string; dt: string }
export type StoreKey = "auth-user-id" | "auth-account-id"
export type VaultKey = "remote-database" | "remote-server" | "twenty-api-key" | "deepgram-api-key" | "aws-access-key-id" | "aws-secret-access-key" | "aws-region"

/** tauri-specta globals **/

import {
  invoke as TAURI_INVOKE,
} from "@tauri-apps/api/core";
import * as TAURI_API_EVENT from "@tauri-apps/api/event";
import { type WebviewWindow as __WebviewWindow__ } from "@tauri-apps/api/webviewWindow";

type __EventObj__<T> = {
  listen: (
    cb: TAURI_API_EVENT.EventCallback<T>,
  ) => ReturnType<typeof TAURI_API_EVENT.listen<T>>;
  once: (
    cb: TAURI_API_EVENT.EventCallback<T>,
  ) => ReturnType<typeof TAURI_API_EVENT.once<T>>;
  emit: null extends T
  ? (payload?: T) => ReturnType<typeof TAURI_API_EVENT.emit>
  : (payload: T) => ReturnType<typeof TAURI_API_EVENT.emit>;
};

export type Result<T, E> =
  | { status: "ok"; data: T }
  | { status: "error"; error: E };

function __makeEvents__<T extends Record<string, any>>(
  mappings: Record<keyof T, string>,
) {
  return new Proxy(
    {} as unknown as {
      [K in keyof T]: __EventObj__<T[K]> & {
        (handle: __WebviewWindow__): __EventObj__<T[K]>;
      };
    },
    {
      get: (_, event) => {
        const name = mappings[event as keyof T];

        return new Proxy((() => { }) as any, {
          apply: (_, __, [window]: [__WebviewWindow__]) => ({
            listen: (arg: any) => window.listen(name, arg),
            once: (arg: any) => window.once(name, arg),
            emit: (arg: any) => window.emit(name, arg),
          }),
          get: (_, command: keyof __EventObj__<any>) => {
            switch (command) {
              case "listen":
                return (arg: any) => TAURI_API_EVENT.listen(name, arg);
              case "once":
                return (arg: any) => TAURI_API_EVENT.once(name, arg);
              case "emit":
                return (arg: any) => TAURI_API_EVENT.emit(name, arg);
            }
          },
        });
      },
    },
  );
}
